import { DestructiveText, MutedText } from '@/components/ui/typography';

type FormFieldMessagesProps = {
  helperText?: string;
  errorText?: string;
  helperId?: string;
  errorId?: string;
};

export function FormFieldMessages({
  helperText,
  errorText,
  helperId,
  errorId,
}: FormFieldMessagesProps) {
  return (
    <>
      {helperText && (
        <MutedText id={helperId} data-slot="form-field-helper" className="text-xs">
          {helperText}
        </MutedText>
      )}
      {errorText && (
        <DestructiveText id={errorId} role="alert" className="text-xs">
          {errorText}
        </DestructiveText>
      )}
    </>
  );
}
